import {Injectable, Type} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";

@Injectable({providedIn: 'root'})
export class DunningTypeTagService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/bd/dunningTypeTags')
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        return null;
    }
}
